import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';


const adjustColumnWidth = (ws, width) => {
    const colInfo = ws['!cols'] || [];
    for (let i = 0; i < width.length; i++) {
        colInfo[i] = { wch: width[i] };
    }
    ws['!cols'] = colInfo;
};

const excelPrint = (tableData, title, header, headerSize) => {
    const wsa = XLSX.utils.aoa_to_sheet([header]);
    const ws = XLSX.utils.sheet_add_json(wsa, tableData, { skipHeader: true, origin: "A2" });
    if (headerSize) {
        adjustColumnWidth(ws, headerSize);
    }
    const wb = { Sheets: {}, SheetNames: ["data"] };
    wb.Sheets.data = ws;
    const excelBuffer = XLSX.write(wb, {
        bookType: "biff8",
        type: "array",
    });

    const data = new Blob([excelBuffer]);
    FileSaver.saveAs(data, `${title}.xls`);
}

// const pdfPrint = (tableData, title, header, headerTitle) => {
//     const wsa = XLSX.utils.aoa_to_sheet([header]);
//     const ws = XLSX.utils.sheet_add_json(wsa, tableData, { skipHeader: true, origin: "A2" });
//     const wb = { Sheets: {}, SheetNames: ["data"] };
//     wb.Sheets.data = ws;

//     const pdfDoc = new jsPDF();
//     const addHeader = (pdfDoc) => {
//         pdfDoc.setFontSize(20);
//         pdfDoc.text('INDIAN OIL CORPORATION LIMITED', 105, 20, null, null, 'center');
//         pdfDoc.setFontSize(12);
//         pdfDoc.text(`${headerTitle}`, 105, 30, null, null, 'center');
//         pdfDoc.setDrawColor(0, 0, 0);
//         pdfDoc.line(10, 35, 200, 35); // Add a horizontal line below the header
//     };
//     addHeader(pdfDoc);
//     const pdfTable = XLSX.utils.sheet_to_json(ws, { header: 1 });
//     pdfDoc.autoTable({
//         startY: 40,
//         head: [pdfTable[0]],
//         body: pdfTable.slice(1)
//     })
//     // Save PDF
//     pdfDoc.save(`${title}.pdf`);
// }

export {
    excelPrint,
    // pdfPrint
};